import $ from 'jquery';
import popper from 'popper.js';

// BOOTSTRAP
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';

// SLICK SLIDER
import './vendors/slick.min';


// CUSTOM
import "./components/nav-toggle";
import "./components/slider";
import "./components/google-map";
import "./components/content-filter";
import "./components/text-rotate";


$(document).ready(function() {
//jQuery(function(){

    //Accordion
    $('.collapse').on('shown.bs.collapse', function(){
        $(this).parent().addClass("is-open");
        }).on('hidden.bs.collapse', function(){
        $(this).parent().removeClass("is-open");
    });

    $('.js-toggle-search').on('click', function(e) {
        e.preventDefault();
        $('.js-nav-search-form').toggleClass('is-visible');
        if ($('.js-nav-search-form').hasClass('is-visible')) {
            $('.js-nav-search-form').find('input').focus();
        }
    })

    $('.js-nav-search-form input').on('focus', function(e) {
        if (!$('.js-nav-search-form').hasClass('is-visible')) {
            $('.js-nav-search-form').addClass('is-visible');
        }
    });

    $('.js-nav-search-form input').on('blur', function(e) {
        $('.js-nav-search-form').removeClass('is-visible');
    });

}); 

